import { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useJsApiLoader } from '@react-google-maps/api';
import { addLocation } from '../slice/location-slice';
import { googleMapsApiKey } from '../env/environment';

const GOOGLE_MAPS_API_KEY = googleMapsApiKey;

const useUserLocation = () => {
  const autocompleteRef = useRef(null);
  const [address, setAddress] = useState('');
  const [coords] = useState(null);
  const [error, setError] = useState('');
  useJsApiLoader({
    googleMapsApiKey: googleMapsApiKey,
    libraries: ['places', 'marker'],
  });
  const dispatch = useDispatch();
  const storedLocation = useSelector((state) => state.location);

  useEffect(() => {
    if (storedLocation?.coords?.lat) return;

    if (!navigator.geolocation) {
      setError('Geolocation is not supported by this browser.');
      return;
    }
    navigator.geolocation.getCurrentPosition(
      async (position) => {
        const { latitude, longitude } = position.coords;
        try {
          const response = await fetch(
            `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=${GOOGLE_MAPS_API_KEY}`
          );
          const data = await response.json();

          if (data.status === 'OK') {
            const locationData = {
              address:
                data.results[0]?.formatted_address || 'Address not found',
              coords: { lat: latitude, lng: longitude },
            };

            dispatch(addLocation(locationData));
          } else {
            setError('Error fetching address.');
          }
        } catch {
          setError('Failed to fetch address.');
        }
      },
      (err) => {
        const errorMessages = {
          1: 'Location access denied. Please enable location permissions.',
          2: 'Location unavailable.',
          3: 'Location request timed out. Try again.',
        };
        setError(errorMessages[err.code] || 'An unknown error occurred.');
      }
    );
  }, [dispatch, storedLocation]);

  return {
    location: storedLocation,
    error,
    address,
    coords,
    autocompleteRef,
    setAddress,
  };
};

export default useUserLocation;
